import { useQuery } from '@tanstack/react-query';
import type { GeoPoint } from '@app/shared/geo';
import { api } from '../api';

/**
 * A place as an event keeps it (the default place of a new event, owner 2026-10-30 22:20, and the place of a rule of
 * „Skojarzenia miejsc”, 22:23). The server leaves out the parts the role does not see in events (rule 7a).
 */
export type PlaceValue = { location: string; locationAddress: string; locationPoint: GeoPoint | null; locationApprox: boolean; venueId: string | null; googlePlaceId: string };
export type PlaceRule = { id: string; phrase: string; place: Partial<PlaceValue>; version: number };

export const PLACE_RULES_KEY = ['events', 'place-rules'] as const;
export const EMPTY_PLACE: PlaceValue = { location: '', locationAddress: '', locationPoint: null, locationApprox: true, venueId: null, googlePlaceId: '' };

/** A place as sent by the server, with what it left out at the event's defaults. */
export const fullPlace = (p: Partial<PlaceValue> | null | undefined): PlaceValue => ({ ...EMPTY_PLACE, ...(p ?? {}) });

/** „Sopot, Mamuszki 14”: the name, else the address. */
export const placeLabel = (p: Partial<PlaceValue>): string => (p.location ?? '').trim() || (p.locationAddress ?? '').trim();

/** The rules (everyone who sees events reads them); none while they load or when they could not be read. */
export function usePlaceRules(enabled = true) {
  return useQuery({ queryKey: PLACE_RULES_KEY, enabled, retry: false, staleTime: 60_000, queryFn: () => api<{ rules: PlaceRule[] }>('/api/events/place-rules') });
}
